import React, { Component } from "react";
import closeIcon from "../img/icons/close.svg";
import "./closeButton.scss";

class CloseButton extends Component {
  render() {
    return (
      <img className="CloseButton" src={closeIcon} alt="Close the pop-up" />
    );
  }
}

export default CloseButton;
